<template>
  <div class="searchbar fr ac jc">
    <div class="search_cont fr ac jsb">
      <div class="logo">
        <img src="/static/imgs/home/logo.png" class="cursor" alt @click="go('/')" />
      </div>
      <div class="middle">
        <div class="search_box fr ac" @mouseleave="history_show = false">
          <i class="el-icon-search search_icon"></i>
          <input type="text" v-model="value" class="input_cont" @click="history_show = true" />
          <button class="search_btn fz18 white fr ac jc cursor" @click="submit">搜索</button>
          <div class="history" v-show="history_show && history.length">
            <p
              class="mr20 cursor history_item fz14 black"
              @click.stop="go(`/home/mall?goods_name=${i}`);value=i"
              v-for=" (i,k) in history"
              :key="k"
            >{{i}}</p>
            <div class="history_bottom fr ac jfe fz12 black pr10">
              <span class="cursor underline" @click="deletehistory">清除历史</span>
            </div>
          </div>
        </div>
        <div class="fr ac mt20 grey"></div>
      </div>
      <div class="fc ac jc">
        <img src="/static/imgs/home/Wechat.jpeg" alt class="wechat" />
        <p class="fz14 mt10">益发公众号</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { value: "", history: [], history_show: false };
  },
  created() {
    this.history = JSON.parse(localStorage.getItem("history")) || [];
  },
  methods: {
    deletehistory() {
      this.history = [];
      localStorage.setItem("history", []);
    },
    submit() {
      if (this.value) {
        if (this.history.length >= 10) {
          this.history.shift();
        }
        this.history.push(this.value);
      }
      localStorage.setItem("history", JSON.stringify(this.history));
      this.go(`/home/mall?goods_name=${this.value}`);
    },
  },
};
</script>

<style scoped lang="scss">
.searchbar {
  .search_cont {
    width: 1200px;
    height: 160px;
    .logo {
      width: 162px;
      height: 80px;
      position: relative;
      img {
        height: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
    .middle {
      .search_box {
        width: 600px;
        height: 44px;
        position: relative;
        .search_icon {
          z-index: 33;
          display: inline-block;
          width: 16px;
          height: 16px;
          position: absolute;
          left: 5px;
          bottom: 0;
          top: 0;
          color: #b3b3b3;
          margin: auto;
        }
        .input_cont {
          border: 1px solid #b3b3b3;
          border-right: none;
          width: 80%;
          padding-left: 25px;
          height: 100%;
          position: relative;
          &:focus {
            border-color: #458ef6;
          }
        }
        .search_btn {
          position: absolute;
          right: 0;
          top: 0;
          width: 20%;
          height: 100%;
          background-color: #458ef6;
          border-color: #458ef6;
          border-radius: 0;
          color: white;
        }
        .history {
          z-index: 30;
          position: absolute;
          background-color: #fff;
          left: 0;
          top: 44px;
          width: 80%;
          border: 1px solid #eeeeee;
          .history_item {
            width: 100%;
            &:hover {
              background-color: #eeeeee;
            }
            padding: 6px 10px;
          }
          .history_bottom {
            width: 100%;
            height: 30px;
            background-color: #fafafa;
          }
        }
      }
    }
    .wechat {
      width: 100px;
      height: 100px;
    }
  }
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchBar.vue